// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-3pWyV","text":"index-text-oFtPb"};